import { ComponentType } from 'react';
import { TEXT_COLORS } from '@/common/theme/tokens';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, Props } from '@fortawesome/react-native-fontawesome';

export function Icon({ icon, color, ...props }: TIconProps) {
  const iconColor = color ? TEXT_COLORS[color] : TEXT_COLORS['neutral30'];
  if (typeof icon === 'function') {
    const CustomIcon = icon;
    return <CustomIcon {...props} color={iconColor} />;
  }
  // We are using rem units as strings in some old web components and FontAwesomeIcon
  // doesn't support them. We need to convert them to numbers.
  const { width, height, size, ...rest } = props;
  const actualSize = size ?? getSizeFromMetrics({ width, height });
  return (
    <FontAwesomeIcon
      {...rest}
      icon={icon}
      color={iconColor}
      size={actualSize}
    />
  );
}

function getSizeFromMetrics(metrics: Pick<TIconProps, 'width' | 'height'>) {
  let width = typeof metrics.width === 'string' ? `${metrics.width}` : 16;
  let height = typeof metrics.height === 'string' ? `${metrics.height}` : 16;

  if (typeof width === 'string') {
    width = width.includes('rem') ? parseFloat(width) * 10 : parseFloat(width);
  }
  if (typeof height === 'string') {
    height = height.includes('rem')
      ? parseFloat(height) * 10
      : parseFloat(height);
  }

  return height ?? width;
}

export type TIconProps = {
  icon: IconProp | ComponentType<any>;
  color?: keyof typeof TEXT_COLORS;
  className?: string;
} & Omit<Props, 'icon'>;
